// @mui
import { Tooltip, Stack, Typography, Box } from '@mui/material';
// auth
import { useAuthContext } from '../../auth/useAuthContext';
// layouts
import LoginLayout from '../../layouts/login';
//
import AuthLoginForm from './AuthLoginForm';

// ----------------------------------------------------------------------

export default function Login() {
  const { method } = useAuthContext();

  return (
    <LoginLayout>
      <Stack spacing={2} sx={{ mb: 5, position: 'relative' }}>
        <Typography variant="h4">Connectez-vous </Typography>

        {/* <Box
          component="img"
          alt={method}
          src={`/assets/icons/vert.png`}
          sx={{ width: 42, height: 42, position: 'absolute', right: 0 }}
        /> */}
      </Stack>

      <AuthLoginForm />
    </LoginLayout>
  );
}
